module.exports = __webpack_public_path__ + "img/ia.d40a7d74.svg";